// services/locationService.js
import API from '../api/api';

export const locationService = {
    getLocationSubjects: async (location_id) => {
      const response = await API.get('/location_subject_list', { params: { location_id } });
      return response.data.data || [];
    },
    getSemesterLocation: async (location_id) => {
    const response = await API.get('/semester_location_list', { params: { location_id: location_id} });
    return response.data.data || [];
    },
    getLocationContacts: async (location_id) => {
      const response = await API.get('/get_location_contact', { params: { location_id} });
      return response.data.data || [];
      },
    getLocations: async () => {
      const response = await API.get('/get_locations');
      return response.data.data || [];
    },
    getLocationTutors: async (tutor_id) => {
      const response = await API.get('/get_tutor_locations', {params: {tutor_id}});
      return response.data.data || [];
    },
    getLocationPrograms: async (location_id) => {
      const response = await API.get("/location_program_list", {params: {location_id}});
      return response.data.data || []; 
    },
    createProgramLocation: async (payload) => {
      const response = await API.post('/create_program_location', payload);
      return response.data;
    },
    createSemesterLocation: async (payload) => {
      const response = await API.post('/create_semester_location', payload);
      return response.data;
    },
    createSubjectLocation: async (payload) => {
      const response = await API.post('/create_subject_location', payload);
      return response.data;
    },
    createLocation: async (payload) => {
      const response = await API.post('/create_location', { ...payload});
      return response.data;
    },
    createLocationContact: async (payload) => {
      const response = await API.post('/create_location_contact', { ...payload});
      return response.data;
    },
    updateLocation: async (payload) => {
      const response = await API.post('/update_location', { ...payload});
      return response.data;
    },
    deleteLocation: async (id) => {
      const response = await API.post('/delete_location', {id});
      return response.data;
    },
    deleteProgramLocation: async (program_id, location_id) => {
      const response = await API.post('/delete_program_location', { 
        program_id, 
        location_id 
      });
      return response.data;
    },
    deleteSemesterLocation: async (id) => {
      const response = await API.post('/delete_semester_location', { id });
      return response.data;
    },
    deleteSubjectLocation: async (subject_id, location_id) => {
      const response = await API.post('/delete_subject_location', { 
        subject_id, 
        location_id 
      });
      return response.data;
    },
  
};


